﻿// <reference path = "./libs/phaser.d.ts" />

import * as PlayerModule from "./Player";

export namespace BattleCity
{
    export class Level01 extends Phaser.State
    {
        public offsetX: number = 32;
        public offsetY: number = 16;

        private player: Phaser.Sprite;

        private borders: Phaser.Group;
        private bricks: Phaser.Group;
        private blocks: Phaser.Group;

        private pieses: string =
"..........................\
..........................\
..##..##..##..##..##..##..\
..##..##..##..##..##..##..\
..##..##..##..##..##..##..\
..##..##..##..##..##..##..\
..##..##..##@@##..##..##..\
..##..##..##@@##..##..##..\
..##..##..##..##..##..##..\
..##..##..........##..##..\
..##..##..........##..##..\
..........##..##..........\
..........##..##..........\
##..####..........####..##\
@@..####..........####..@@\
..........##..##..........\
..........######..........\
..##..##..######..##..##..\
..##..##..##..##..##..##..\
..##..##..##..##..##..##..\
..##..##..##..##..##..##..\
..##..##..........##..##..\
..##..##..........##..##..\
..##..##...####...##..##..\
...........#..#...........\
...........#..#...........\
";
        create()
        {
            this.physics.startSystem(Phaser.Physics.ARCADE);

            this.borders = this.game.add.group();
            this.borders.enableBody = true;

            this.bricks = this.game.add.group();
            this.bricks.enableBody = true;

            this.blocks = this.game.add.group();
            this.blocks.enableBody = true;

            let x = 0, y = 0;
            for (let row = 0; row < 26; ++row)
            {
                for (let col = 0; col < 26; ++col)
                {
                    if (this.pieses[row * 26 + col] === "#")
                    {
                        this.add.sprite(col * 16 + this.offsetX, row * 16 + this.offsetY, "battleCityScene", "brick2.png", this.bricks);
                        this.add.sprite(col * 16 + 8 + this.offsetX, row * 16 + this.offsetY, "battleCityScene", "brick1.png", this.bricks);
                        this.add.sprite(col * 16 + this.offsetX, row * 16 + 8 + this.offsetY, "battleCityScene", "brick1.png", this.bricks);
                        this.add.sprite(col * 16 + 8 + this.offsetX, row * 16 + 8 + this.offsetY, "battleCityScene", "brick2.png", this.bricks);
                    }
                    if (this.pieses[row * 26 + col] === "@")
                    {
                        this.add.sprite(col * 16 + this.offsetX, row * 16 + this.offsetY, "battleCityScene", "block.png", this.blocks);
                    }
                }
            }
            this.bricks.setAll("body.immovable", true);
            this.blocks.setAll("body.immovable", true);

            // Gray borders
            // Top
            let top = this.add.sprite(0, 0, "battleCityScene", "gray_block.png", this.borders);
            top.width = this.world.width;
            top.height = 16;
            // Bottom
            let bottom = this.add.sprite(0, this.world.height - 16, "battleCityScene", "gray_block.png", this.borders);
            bottom.width = this.world.width;
            bottom.height = 16;
            // Right
            let right = this.add.sprite(this.world.width - 64, 0, "battleCityScene", "gray_block.png", this.borders);
            right.width = 64;
            right.height = this.world.height;
            // Left
            let left = this.add.sprite(0, 0, "battleCityScene", "gray_block.png", this.borders);
            left.width = 32;
            left.height = this.world.height;
            // Set all the borders to be immovable
            this.borders.setAll("body.immovable", true);

            // Base
            let base = this.add.sprite(12 * 16 + this.offsetX, 24 * 16 + this.offsetY, "battleCityScene", "base.png");

            // Player
            this.player = new PlayerModule.BattleCity.Player(this.game, 9 * 16 + this.offsetX, 25 * 16 + this.offsetY);
            this.player.body.setSize(26, 26, 3, 3);
            //this.player.body.width = 28;
            //this.player.body.height = 28;
        }

        update()
        {
            this.game.physics.arcade.collide(this.player, this.borders);
            this.game.physics.arcade.collide(this.player, this.bricks);
            this.game.physics.arcade.collide(this.player, this.blocks);
        }
    }
}
